export default __webpack_public_path__ + "static/media/nura.d3e0d0bb.jpg";